import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/Elements'
import { useAppConfirmModal } from '@/features/app/hooks'
import { useBillingPaymentMethodUpdateDefaultMutation } from '@/features/billing/store'
import { PaymentMethodModel } from '@/features/billing/types'
import { useNotify } from '@/hooks'

interface IProps {
  data: PaymentMethodModel
  onSuccess?: (data: any) => void
}

export const DefaultControl = ({ data }: IProps) => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const [update, { isLoading }] = useBillingPaymentMethodUpdateDefaultMutation()

  const onConfirm = async () => {
    try {
      await update({ params: { payment_method: data?.id } }).unwrap()
    } catch (error: any) {
      showNotification({
        type: 'error',
        message: error?.data?.message || t('error'),
      })
    }
  }

  const { open } = useAppConfirmModal({ onConfirm })

  return (
    <>
      <Button variant={'outline'} onClick={() => open()} loading={isLoading} size={'xs'} compact>
        {t('default')}
      </Button>
    </>
  )
}
